module.exports = __webpack_public_path__ + "static/media/NSP01@m.9d1367ed.jpg";